import { createContext, useContext, useState, useCallback } from 'react';

const HomeRefreshContext = createContext(null);

export function HomeRefreshProvider({ children }) {
    const [refreshKey, setRefreshKey] = useState(0);

    const triggerRefresh = useCallback(() => {
        setRefreshKey(k => k + 1);
    }, []);

    return (
        <HomeRefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
            {children}
        </HomeRefreshContext.Provider>
    );
}

export function useHomeRefresh() {
    return useContext(HomeRefreshContext);
}
